import { Vector3 } from 'three';
import ObjectView from '@scene/views/object-view';
import Axis from '@scene/axis';

export default {
  mode: ObjectView.mode.MODE_3D,
  orthographicCamera: {
    position: new Vector3(0.0007121568184116151, 712.1446482277966, -0.000005268009116589875),
    zoom: 10
  },
  perspectiveCamera: {
    position: new Vector3(1631.2540080318491, 1267.62575951004965, 1438.25777041770465),
    target: new Vector3(72.77295202015304, -95.87377599072285, -60.48791403312775),
    zoom: 1
  },
  axis: {
    position: null,
    orientation3D: Axis.types.Y_TOP,
    orientation2D: Axis.types.Y_TOP_2D
  }
};



// WEBPACK FOOTER //
// ./src/reducers/camera/defaults/rebarReinforcement.js